import { useCallback, useState } from "react";

/**
 * This function returns an array with three elements, including the active index of a selected product
 * card and functions to handle selecting and clearing the product card.
 * @returns An array containing three elements: `activeIndex`, `handleSelectProductCard`, and
 * `handleClearProductCard`.
 */
function useSelectedProductCard() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleSelectProductCard = useCallback((index) => {
    setActiveIndex(index);
  }, []);

  const handleClearProductCard = useCallback(() => {
    setActiveIndex(null);
  }, []);

  return { activeIndex, handleSelectProductCard, handleClearProductCard };
}

export default useSelectedProductCard;
